import { Link } from "react-router-dom";

export const LEANING = {
  left: ["Left", "bg-rose-50 text-rose-800 border-rose-200"],
  "centre-left": ["Centre-left", "bg-pink-50 text-pink-800 border-pink-200"],
  neutral: ["Neutral / official", "bg-slate-100 text-slate-700 border-slate-300"],
  "centre-right": ["Centre-right", "bg-sky-50 text-sky-800 border-sky-200"],
  right: ["Right", "bg-blue-50 text-blue-800 border-blue-200"],
};
export const LEANING_ORDER = ["left", "centre-left", "neutral", "centre-right", "right"];

export const LeaningBadge = ({ leaning, testid }) => {
  const [label, cls] = LEANING[leaning] || ["Not rated", "bg-white text-slate-500 border-slate-200"];
  return <span className={`inline-flex shrink-0 rounded-full border px-2 py-0.5 text-[11px] font-semibold ${cls}`} data-testid={testid}>{label}</span>;
};

export const SourcesButton = () => (
  <Link to="/facts/sources" className="inline-flex items-center gap-1.5 rounded-full border border-[hsl(var(--facts))]/40 bg-white px-4 py-2 text-sm font-medium text-[hsl(var(--facts))] transition-colors hover:bg-emerald-50" data-testid="approved-sources-btn">
    <span className="flex h-3 w-6 overflow-hidden rounded-full"><span className="w-1/2 bg-rose-400" /><span className="w-1/2 bg-blue-400" /></span>Our approved sources
  </Link>
);

const SEG = [["left", "bg-rose-400", "left-leaning"], ["neutral", "bg-slate-400", "neutral/official"], ["right", "bg-blue-500", "right-leaning"]];

export const BalanceMeter = ({ b, testid }) => {
  const total = b ? b.left + b.neutral + b.right : 0;
  if (!total) return null;
  const label = SEG.filter(([k]) => b[k]).map(([k, , t]) => `${b[k]} ${t}`).join(" · ");
  return (
    <div className="mt-3 flex items-center gap-2" data-testid={testid} title={`Sources reporting this: ${label}`}>
      <span className="shrink-0 text-[10px] font-semibold uppercase tracking-wider text-slate-600">L</span>
      <div className="flex h-1.5 w-28 overflow-hidden rounded-full bg-slate-100" aria-label={`Balance of sources: ${label}`}>
        {SEG.map(([k, cls]) => b[k] > 0 && <span key={k} className={cls} style={{ width: `${(b[k] / total) * 100}%` }} />)}
      </div>
      <span className="shrink-0 text-[10px] font-semibold uppercase tracking-wider text-slate-600">R</span>
      <span className="truncate text-[11px] text-slate-600" data-testid={`${testid}-label`}>{label}</span>
    </div>
  );
};
